const p = (n: number) => 1 << n;

export const roles = {
	ADMINISTRATOR: p(1),
	MANAGE_TEAM: p(2),
	MANAGE_ROSTERS: p(3),
	MANAGE_COMPOSITIONS: p(4),
	MANAGE_DISCORD: p(5),
};

export const features = {
	TEST: p(1),
	DISCORD: p(2)
};

export default (cannotCode: number | null) => ({
	hasPermission: (permission: number) => {
		if (cannotCode == null) {
			return false;
		}
		if (cannotCode & roles.ADMINISTRATOR) {
			return true;
		}

		return (cannotCode & permission) !== 0;
	},
	hasFeaturePermission: (permission: number) => {
		if (cannotCode == null) {
			return false;
		}
		return (cannotCode & permission) !== 0;
	}
});